export * from 'alto-react-base-auth/lib/settings'

import { loginKeyBase, registrationKeyBase } from 'alto-react-base-auth/lib/settings'

# user bar

export userBarKey = 'auth.user_bar'

export userBarSetting = (settings) ->
  setting = settings.safeFindBy(key: userBarKey)?.value or {}

  signature: setting.signature ? 'username_and_fullname'

# login

export clientSelectKey = loginKeyBase + 'client_select'

export clientSelectSetting = (settings) ->
  setting = settings.safeFindBy(key: clientSelectKey)?.value or {}

  enabled:          setting.enabled           ? false
  mustAuthenticate: setting.must_authenticate ? true

# registration

export billVerificationKey = registrationKeyBase + 'bill_verification'

export billVerificationSetting = (settings) ->
  setting = settings.safeFindBy(key: billVerificationKey)?.value or {}

  enabled:                    setting.enabled                       ? true
  showReason:                 setting.show_reason                   ? true
  pluralGenetiveBusinessName: setting.plural_genitive_business_name ? 'provozoven'

# profile

export generalProfileKey  = 'auth.profile'
export profileKeyBase     = generalProfileKey + '.'
export pinKey             = profileKeyBase + 'pin'
export hiddenGroupsKey    = profileKeyBase + 'hidden_groups'
export collapsedGroupsKey = profileKeyBase + 'collapsed_groups'
export hiddenFieldsKey    = profileKeyBase + 'hidden_fields'
export requiredFieldsKey  = profileKeyBase + 'required_fields'

frontendNameFor = (field) -> field.split('.').map(_.camelCase).join('.')

export generalProfileSetting = (settings) ->
  setting = settings.safeFindBy(key: generalProfileKey)?.value or {}

  enabled: setting.enabled ? true

export pinSetting = (settings) ->
  setting = settings.safeFindBy(key: pinKey)?.value or {}

  enabled:   setting.enabled    ? false
  minLength: setting.min_length ? 3

export hiddenGroupsSetting = (settings) ->
  setting = settings.safeFindBy(key: hiddenGroupsKey)?.value or []

  setting.map(frontendNameFor)

export collapsedGroupsSetting = (settings) ->
  setting = settings.safeFindBy(key: collapsedGroupsKey)?.value or ['address', 'company']

  setting.map(frontendNameFor)

export hiddenFieldsSetting = (settings) ->
  setting = settings.safeFindBy(key: hiddenFieldsKey)?.value or []

  setting.map(frontendNameFor)

export requiredFieldsSetting = (settings) ->
  setting = settings.safeFindBy(key: requiredFieldsKey)?.value or []

  setting.map(frontendNameFor)

# mailing

export supportMailingKeyBase = 'mailing.support.'

export contactFormKey     = supportMailingKeyBase + 'contact_form'
export contactFormSetting = (settings) ->
  setting    = settings.safeFindBy(key: contactFormKey)?.value ? {}
  enabled    = setting.enabled    ? true
  categories = setting.categories ? ['jiné']

  { enabled, categories }
